export default __webpack_public_path__ + "static/media/Help.d53dd67d.svg";